<template>
  <div>
    <v-dialog v-model="openModal" max-width="700">
      <v-card>
        <v-card-title class="grey lighten-3">
          <v-icon left color="info">mdi-credit-card-outline</v-icon>
          Detalle de pago
          <v-spacer></v-spacer>
          <span class="text-body-2 grey--text text--darken-1" v-text="detallePago.codigoVenta"></span>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-row v-show="!mostrarContenido">
            <v-col cols="12" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="60"
                :width="6"
              ></v-progress-circular>
            </v-col>
          </v-row>

          <template v-show="mostrarContenido">
            <v-row dense>
              <v-col
                v-for="campo in camposDetalle"
                :key="campo.label"
                :cols="campo.cols || 6"
                :sm="campo.sm || 4"
              >
                <div class="stat-tile">
                  <div class="d-flex align-center mb-1">
                    <v-icon x-small color="info" class="mr-1">{{ campo.icon }}</v-icon>
                    <span class="text-caption grey--text text--darken-1 text-uppercase" v-text="campo.label"></span>
                  </div>
                  <div
                    class="text-body-2 font-weight-medium text-truncate"
                    :title="campo.valor"
                    v-text="campo.valor || '--'"
                  ></div>
                </div>
              </v-col>
            </v-row>

            <p class="mt-4 mb-2 font-weight-bold">Resumen de costos</p>

            <v-simple-table dense class="tabla-items mb-3">
              <thead>
                <tr>
                  <th>ITEM</th>
                  <th class="text-right">P. MONTURA</th>
                  <th class="text-right">P. LUNA</th>
                  <th class="text-right">P. VENTA</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx) in detallePago.items"
                  :key="idx"
                  :class="item.esCargo ? 'fila-cargo' : ''"
                >
                  <td>
                    <div v-text="item.nombre"></div>
                    <div v-if="item.codigo" class="grey--text text--darken-1 text-caption" v-text="item.codigo"></div>
                  </td>
                  <td class="text-right" v-text="formatMoney(item.precioMontura)"></td>
                  <td class="text-right" v-text="formatMoney(item.precioLuna)"></td>
                  <td class="text-right" v-text="formatMoney(item.precioVenta)"></td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-simple-table dense class="resumen-costos">
              <tbody>
                <tr>
                  <td>Cupón</td>
                  <td class="text-right" v-text="detallePago.cupon || '--'"></td>
                </tr>
                <tr class="total-row">
                  <td class="font-weight-bold">Total (monto pagado)</td>
                  <td class="text-right font-weight-bold" v-text="formatMoney(detallePago.total)"></td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="openModal = false">
            <v-icon left>mdi-backspace</v-icon> Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openModal: false,
      idventa: "",
      mostrarContenido: false,
      detallePago: {
        idtransaccion: "",
        codigoVenta: "",
        tipoPago: "",
        codigoPago: "",
        cuotas: 0,
        fechaExpiracion: "",
        correo: "",
        fechaPago: "",
        horaPago: "",
        cupon: "",
        total: null,
        items: [],
      },
    };
  },
  props: {
    objModalDetallePago: {
      type: Object,
    },
  },
  computed: {
    camposDetalle() {
      return [
        { label: "Tipo de pago", icon: "mdi-cash-multiple", valor: this.detallePago.tipoPago },
        { label: "Código de pago", icon: "mdi-pound", valor: this.detallePago.codigoPago },
        { label: "Código de transacción", icon: "mdi-swap-horizontal", valor: this.detallePago.idtransaccion },
        { label: "Cuotas", icon: "mdi-format-list-numbered", valor: this.detallePago.cuotas },
        { label: "Fecha de pago", icon: "mdi-calendar", valor: this.detallePago.fechaPago },
        { label: "Hora de pago", icon: "mdi-clock-outline", valor: this.detallePago.horaPago },
        { label: "Fecha de expiración", icon: "mdi-calendar-alert", valor: this.detallePago.fechaExpiracion },
        { label: "Email", icon: "mdi-email-outline", valor: this.detallePago.correo, cols: 12, sm: 12 },
      ];
    },
  },
  watch: {
    objModalDetallePago(val) {
      this.mostrarContenido = false;
      this.openModal = val.openModal;
      this.idventa = val.idventa;
      this.getDetallePago();
    },
  },

  methods: {
    formatMoney(valor) {
      if (valor == null) return "--";
      const numero = Number(valor);
      return (numero < 0 ? "-S/ " : "S/ ") + Math.abs(numero).toFixed(2);
    },

    getDetallePago() {
      this.mostrarContenido = false;
      this.axios({
        method: "POST",
        url: "api/panel/ventas/v2/getDetallePago",
        data: {
          idventa: this.idventa,
        },
      })
        .then((response) => {
          const venta = response.data.venta;
          this.detallePago.idtransaccion = venta.idtransaccion ?? '';
          this.detallePago.codigoVenta = venta.codigo_venta;
          this.detallePago.tipoPago = venta.metodoPago.descripcion;
          this.detallePago.codigoPago =
            venta.metodoPago.descripcion == "PAGO-EFECTIVO"
              ? venta.pago_cip
              : venta.pago_ticket;
          this.detallePago.cuotas = venta.pago_cuotas;
          this.detallePago.fechaExpiracion = this.$moment(venta.pago_expira_cip).format(
            "DD/MM/YYYY hh:mm A"
          );
          this.detallePago.correo = venta.pago_email;
          this.detallePago.fechaPago = venta.fecha_pago
            ? this.$moment(venta.fecha_pago).format("DD/MM/YYYY")
            : '';
          this.detallePago.horaPago = venta.fecha_pago
            ? this.$moment(venta.fecha_pago).format("hh:mm A")
            : '';
          this.detallePago.cupon = venta.cupon ? venta.cupon.nombre : '';
          this.detallePago.total = venta.total_final;

          const precioEnvio = Number(venta.precio_envio || 0) + Number(venta.precio_entrega_rapido || 0);
          const descuento = Number(venta.descuento || 0);

          const itemsProductos = (venta.detalle || []).map((item) => {
            const precioMontura = Number(item.precio_producto || 0);
            const precioLuna = Number(item.precio_luna || 0);
            return {
              nombre: item.producto ? item.producto.nombre : '',
              codigo: item.producto ? item.producto.codigo : '',
              precioMontura: precioMontura,
              precioLuna: precioLuna,
              precioVenta: precioMontura + precioLuna,
            };
          });

          this.detallePago.items = [
            ...itemsProductos,
            { nombre: 'Envío', esCargo: true, precioMontura: null, precioLuna: null, precioVenta: precioEnvio },
            { nombre: 'Descuento', esCargo: true, precioMontura: null, precioLuna: null, precioVenta: -descuento },
          ];
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.mostrarContenido = true;
        });
    },
  },
};
</script>

<style scoped>
.stat-tile {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  padding: 6px 10px;
  height: 100%;
}
.tabla-items ::v-deep th,
.tabla-items ::v-deep td {
  font-size: 12px;
  padding: 4px 8px;
}
.tabla-items ::v-deep tr.fila-cargo td {
  font-style: italic;
  color: rgba(0, 0, 0, 0.6);
}
.resumen-costos ::v-deep td {
  border: none !important;
  padding: 2px 8px;
  height: 28px;
}
.total-row td {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
